import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getProspect = async email => {
  return (await requestFunnel.get(`prospects/${email}`, getOptions())).data;
};

export const setSignatureDate = async (prospectId, signatureDate) => {
  const body = { signatureDate };
  return (await requestFunnel.patch(`prospects/signature-date/${prospectId}`, body, getOptions())).data;
};

export const getDocumentProspect = async (prospectId, documentKey) => {
  const options = getOptions();
  options.responseType = 'blob';
  const result = await requestFunnel.get(`prospects/${prospectId}/documents/${documentKey}`, options);
  return result.data;
};

const addProspectDocument = async (prospectIdNumber, fileName, file, useAuthToken) => {
  const options = useAuthToken ? getOptions() : { headers: {} };
  options.headers['Content-Type'] = 'multipart/form-data';
  options.timeout = 120000;
  const formData = new FormData();
  formData.append(fileName, file);
  const result = await requestFunnel.patch(`prospects/${prospectIdNumber}`, formData, options);
  return result.data;
};

export const addDocumentProspect = (prospectIdNumber, fileName, file) => {
  return addProspectDocument(prospectIdNumber, fileName, file, true);
};

export const addUserProspect = async body => {
  const options = getOptions();
  const result = await requestFunnel.post('/auth/register-prospect', body, options);
  let resultSendEmail = false;
  if (result) {
    resultSendEmail = await requestFunnel.get(`/prospects/notification/${body.email}`, body, options);
  }
  return resultSendEmail ? result.data : null;
};

export const verifyToken = async token => {
  return requestFunnel.post('auth/verify-token', { token });
};
